import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogsInfo({
  openInfoDialog,
  setOpenInfoDialog,
  tripInfo,
  cardTitle,
  difficulty,
  distance,
  heightGain,
  startPoint,
  region,
  tripDate,
}) {
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpenInfoDialog(false);
  };

  return (
    <div>
      {/* <Button
        variant="outlined"
        onClick={handleClickOpen}
        sx={{ color: "white" }}
        class="css-sghohy-MuiButtonBase-root-MuiButton-root"
      >
        GPX
      </Button> */}

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openInfoDialog}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Trip info
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom variant="h6">
            {cardTitle}
          </Typography>

          <Typography gutterBottom>
            <br></br>
          </Typography>
          <Typography gutterBottom>{tripInfo}</Typography>
          <Typography gutterBottom>
            <br></br>
          </Typography>

          <Typography gutterBottom></Typography>

          <Typography gutterBottom>region: {region}</Typography>

          <Typography gutterBottom>date: {tripDate}</Typography>

          <Typography gutterBottom>{difficulty}</Typography>

          <Typography gutterBottom></Typography>
          <Typography gutterBottom>distance: {distance} km</Typography>

          <Typography gutterBottom></Typography>
          <Typography gutterBottom>
            total height gain: {heightGain} m
          </Typography>

          <Typography gutterBottom></Typography>
          <Typography gutterBottom>start point: {startPoint}</Typography>

          <Typography gutterBottom></Typography>
          <Typography gutterBottom>end point: {startPoint}</Typography>

          <Typography gutterBottom></Typography>
          <Typography gutterBottom>type: loop</Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
